import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCustomerServiceFeaturesRoute: InvariantJiraRoute = {
	name: 'project-settings-customer-service-features',
	path: '/jira/servicedesk/projects/:projectKey/settings/features',
	exact: true,
};
